const BIRDS = [
  { top: "6%", size: 54, dur: 28, delay: 0 },
  { top: "12%", size: 34, dur: 34, delay: -14 },
  { top: "20%", size: 44, dur: 30, delay: -22 },
  { top: "32%", size: 30, dur: 36, delay: -6 },
  { top: "44%", size: 50, dur: 32, delay: -25 },
  { top: "56%", size: 36, dur: 35, delay: -16 },
  { top: "68%", size: 46, dur: 29, delay: -9 },
  { top: "80%", size: 32, dur: 38, delay: -30 },
  { top: "90%", size: 40, dur: 33, delay: -3 },
];

const Bird = ({ size, flap }) => (
  <svg width={size} height={size * 0.6} viewBox="0 0 50 30" fill="currentColor" aria-hidden>
    <g className="bird-wing" style={{ animationDuration: `${flap}s` }}>
      <path d="M25 18 C18 6 8 4 0 8 C9 9 16 13 22 20 Z" />
      <path d="M25 18 C32 6 42 4 50 8 C41 9 34 13 28 20 Z" />
    </g>
    <ellipse cx="25" cy="19" rx="4.5" ry="2.4" />
  </svg>
);

const LEAVES = Array.from({ length: 10 }, (_, i) => ({ left: `${(i * 37) % 100}%`, dur: 18 + (i % 4) * 5, delay: -i * 3.1, size: 10 + (i % 3) * 5 }));

export const NatureBackdrop = () => (
  <div aria-hidden data-testid="nature-backdrop" className="pointer-events-none absolute inset-0 overflow-clip">
    <img src="/assets/frame_5.webp" alt="" className="nature-breathe absolute bottom-0 left-0 h-[75%] w-full scale-x-[-1] object-cover opacity-[0.38]" />
    <div className="absolute inset-x-0 bottom-0 h-[75%] bg-gradient-to-b from-[#eef0ea] via-[#eef0ea]/30 to-[#eef0ea]/60" />
    <div className="light-drift absolute left-[6%] top-[35%] h-[460px] w-[460px] rounded-full bg-[#d9b45a]/20 blur-3xl" />
    <div className="light-drift absolute right-[4%] top-[62%] h-[420px] w-[420px] rounded-full bg-[#7a8f4f]/20 blur-3xl [animation-delay:-9s]" />
    <div className="absolute inset-0">
      <div className="sticky top-0 h-screen overflow-hidden">
    {LEAVES.map((l, i) => (
      <span
        key={`leaf-${i}`}
        className="leaf-fall absolute top-0 text-[#4c6b3a] opacity-40"
        style={{ left: l.left, animationDuration: `${l.dur}s`, animationDelay: `${l.delay}s` }}
      >
        <svg width={l.size} height={l.size} viewBox="0 0 24 24" fill="currentColor"><path d="M5 19C5 9 11 4 20 4c0 9-5 15-15 15zm0 0l8-8" /></svg>
      </span>
    ))}
    {BIRDS.map((b, i) => (
      <div
        key={i}
        data-testid={`bird-${i}`}
        className="bird-fly absolute left-0 text-[#1d3326] opacity-40"
        style={{ top: b.top, animationDuration: `${b.dur}s`, animationDelay: `${b.delay}s` }}
      >
        <div className="bird-bob" style={{ animationDelay: `${i * -0.7}s` }}>
          <Bird size={b.size} flap={0.7 + (i % 3) * 0.15} />
        </div>
      </div>
    ))}
      </div>
    </div>
  </div>
);
